// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"index_headerWrapper__y_JAK","header":"index_header__1VPRg","logo":"index_logo__2B7sn"};